import {createFileRoute} from '@tanstack/react-router';

import {EditSitePage} from '@/modules/sites/pages/EditSitePage';

const RouteComponent = () => {
  const {siteId} = Route.useParams();
  return <EditSitePage siteId={siteId} />;
};

export const Route = createFileRoute('/_authenticated/sites/$siteId_/edit')({
  component: RouteComponent,
});
